import { render, staticRenderFns } from "./DebugInfoVuex.vue?vue&type=template&id=ef2c1162&scoped=true&"
import script from "./DebugInfoVuex.vue?vue&type=script&lang=js&"
export * from "./DebugInfoVuex.vue?vue&type=script&lang=js&"
import style0 from "./DebugInfoVuex.vue?vue&type=style&index=0&id=ef2c1162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2c1162",
  null
  
)

export default component.exports